import { render, staticRenderFns } from "./couponsdialog.vue?vue&type=template&id=467286e5&scoped=true"
import script from "./couponsdialog.vue?vue&type=script&lang=js"
export * from "./couponsdialog.vue?vue&type=script&lang=js"
import style0 from "./couponsdialog.vue?vue&type=style&index=0&id=467286e5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467286e5",
  null
  
)

export default component.exports